import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { fetchPtProjectStats } from '@/api/dashboard/material.js';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { cookRequestParams } from '@/common/request';

var sourceList = [{
  label: '客户自制',
  value: 'ps'
}, {
  label: '内部输出',
  value: 'gm'
}];

var _defaultGroupBy = ['adv_id', 'adv_name', 'tpl_id', 'tpl_name', 'source'];

var dayTime = 1000 * 60 * 60 * 24;

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date() - dayTime * 30, 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')], // 时间
  group_by: [].concat(_defaultGroupBy),
  adv_ids: [],
  tpl_ids: '',
  tpl_name: '',
  adv_search_type: 'adv_name',
  search_field: '',
  keyword: '',
  order: '' // 排序
};

export default {
  mixins: [searchMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      visibleColumn: [].concat(_defaultGroupBy),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      },

      visibleColumns: [],
      filterBarVisible: false
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              // 限定只能选择前180天的日期
              disabledDate: function disabledDate(time) {
                var curDate = new Date().getTime();
                var threeMonths = curDate - 180 * 24 * 3600 * 1000;
                return time.getTime() > Date.now() || time.getTime() < threeMonths;
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
              /* eslint-enable no-mixed-operators */
            }
          }
        },
        adv_search_type: {
          type: 'select',
          prop: 'adv_search_type',
          params: {
            options: [{
              label: '广告主名称',
              value: 'adv_name'
            }, {
              label: '广告主ID',
              value: 'adv_id'
            }]
          }
        },
        adv_ids: {
          prop: 'adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select'
          }
        },
        adv_id: {
          type: 'input',
          prop: 'adv_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID'
          }
        },
        tpl_ids: {
          type: 'input',
          prop: 'tpl_ids',
          params: {
            clearable: true,
            placeholder: '请输入模板ID'
          }
        },
        tpl_name: {
          type: 'input',
          prop: 'tpl_name',
          params: {
            clearable: true,
            placeholder: '请输入模板名称'
          }
        },
        source: {
          prop: 'source',
          type: 'select',
          params: {
            clearable: true,
            placeholder: '制作方',
            options: sourceList
          }
        }
      };
      if (this.query.adv_search_type === 'adv_name') {
        delete list.adv_id;
      } else {
        delete list.adv_ids;
      }
      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var tableList = [{
        label: '广告主ID',
        prop: 'adv_id',
        visible: this.visibleColumn.indexOf('adv_id') > -1,
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return row.adv_id || '-';
          }
        }
      }, {
        label: '广告主名称',
        prop: 'adv_name',
        visible: this.visibleColumn.indexOf('adv_name') > -1,
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return row.adv_name || '-';
          }
        }
      }, {
        label: '模板ID',
        prop: 'tpl_id',
        visible: this.visibleColumn.indexOf('tpl_id') > -1,
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return row.tpl_id || '-';
          }
        }
      }, {
        label: '模板名称',
        prop: 'tpl_name',
        visible: this.visibleColumn.indexOf('tpl_name') > -1,
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            return row.tpl_name || '-';
          }
        }
      }, {
        label: '制作方',
        prop: 'source',
        visible: this.visibleColumn.indexOf('source') > -1,
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            return row.source || '-';
          }
        }
      }, {
        label: '版本个数汇总',
        prop: 'ver_cnt',
        visible: true
      }, {
        label: '普通制作版本个数',
        prop: 'normal_cnt',
        visible: true
      }, {
        label: '多组合制作版本个数',
        prop: 'mgroup_cnt',
        visible: true
      }, {
        label: 'dco制作版本个数',
        prop: 'dco_cnt',
        visible: true
      }, {
        label: '自由编辑制作版本个数',
        prop: 'ps_cnt',
        visible: true
      }, {
        label: '下载&推送次数',
        prop: 'down_cnt',
        visible: true
      }];

      return tableList.filter(function (item) {
        return item.visible;
      });
    },
    dataDimension: function dataDimension() {
      var _d = [{
        label: '广告主ID',
        value: 'adv_id'
      }, {
        label: '广告主名称',
        value: 'adv_name'
      }, {
        label: '模板ID',
        value: 'tpl_id'
      }, {
        label: '模板名称',
        value: 'tpl_name'
      }, {
        label: '制作方',
        value: 'source'
      }];
      return _d;
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    },
    'query.adv_search_type': function queryAdv_search_type(val) {
      if (val === 'adv_name') {
        this.query.adv_id = '';
      } else {
        this.query.adv_ids = [];
      }
    },
    'query.group_by': function queryGroup_by(val) {
      this.query.page = 1;
      // this.handleColumnFilterChange()
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      downloadWithNewWindow(v2Host + '/dashboard/playturbo/project-stats?' + qs.stringify(_extends({}, cookRequestParams(_extends({}, this.query, {
        adv_ids: this.query.adv_search_type === 'adv_name' ? this.query.adv_ids : [this.query.adv_id],
        export: 1
      })))));
    },
    handleSortChange: function handleSortChange(_ref6) {
      var column = _ref6.column,
          prop = _ref6.prop,
          order = _ref6.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var innerParams, res, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                innerParams = _.cloneDeep(params || _this.query);
                _context.next = 5;
                return fetchPtProjectStats(_extends({}, innerParams, {
                  adv_ids: _this.query.adv_search_type === 'adv_name' ? _this.query.adv_ids : [_this.query.adv_id]
                }));

              case 5:
                res = _context.sent;

                _this.visibleColumn = _this.query.group_by;
                sum = _.get(res, 'data.data.sum') ? [_extends({
                  adv_id: 'sum',
                  adv_name: '-',
                  tpl_id: '-',
                  tpl_name: '-',
                  source: '-'
                }, _.get(res, 'data.data.sum'))] : [];
                list = sum.concat(_.get(res, 'data.data.list') || []);

                _this.list = list;
                _this.pagination.total = _.get(res, 'data.data.total') || 0;
                _this.listLoading = false;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 14]]);
      }))();
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.query.group_by = [].concat(_defaultGroupBy);
      this.handleResetSearch();
    }
  }
};